import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70498ad7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between mt-4" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Modal, {
      title: "Agregar Mascota",
      visible: _ctx.showModal,
      "onUpdate:visible": _cache[7] || (_cache[7] = (e) => _ctx.$emit('update:visible', e))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TextField, {
          label: "Departamento",
          model: _ctx.departamento,
          "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.departamento) = $event)),
          type: "text",
          name: "departamento"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Dueño",
          model: _ctx.dueno,
          "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dueno) = $event)),
          type: "text",
          name: "dueno"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Tipo de Animal",
          model: _ctx.tipo,
          "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tipo) = $event)),
          type: "text",
          name: "tipo"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Cantidad",
          model: _ctx.cantidad,
          "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cantidad) = $event)),
          type: "number",
          name: "cantidad"
        }, null, 8, ["model"]),
        _createVNode(_component_TextField, {
          label: "Móvil",
          model: _ctx.movil,
          "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.movil) = $event)),
          type: "text",
          name: "movil"
        }, null, 8, ["model"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.showAlert)
            ? (_openBlock(), _createBlock(_component_Alert, {
                key: 0,
                type: _ctx.type,
                message: _ctx.message
              }, null, 8, ["type", "message"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "px-4 py-2 mr-2 rounded-md bg-gray-300 hover:bg-gray-400 focus:bg-gray-400",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelModal && _ctx.cancelModal(...args)))
          }, "Cancelar"),
          _createElementVNode("button", {
            class: "px-4 py-2 rounded-md bg-primary text-white hover:bg-green-600 focus:bg-green-600",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.savePet && _ctx.savePet(...args))),
            disabled: _ctx.loading
          }, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Agregar"))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _hoisted_6))
          ], 8, _hoisted_2)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_ModalAlert, {
      message: _ctx.message,
      visible: _ctx.showModalAlert,
      option: true,
      onAccept: _ctx.cancelModal
    }, null, 8, ["message", "visible", "onAccept"])
  ]))
}